// extracted by mini-css-extract-plugin
module.exports = {"title":"Online_title__2ImSk"};